import "lazysizes";

import Swup from "swup";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";

import Swiper, { Autoplay, EffectFade } from "swiper";
// Swiper.use([Autoplay, EffectFade]);

import { intro } from "./components/intro";
import { nav } from "./components/nav";
import { collapsibleText } from "./components/collapsible-text";

window.main = window.main || {};

let isHomepage = false;
let isTouchDevice = false;
let isNavToggled = false;
let isPanelToggled = false;
let introRan = false;

function checks() {

  function checkIfTouchDevice() {
    return (
      true ==
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch))
    );
  }

  if (checkIfTouchDevice() === true) {
    document.body.classList.add("is-touch");
    document.body.classList.add("is-mobile-device");
    isTouchDevice = true;
  } else {
    isTouchDevice = false;
  }

  if (document.body.classList.contains("page-home")) {
    isHomepage = true;
  } else {
    isHomepage = false;
  }

}

function setupPlugins() {

  function initSwup() {

    const options = {
      animationSelector: '[class*="transition-fade"]',
      animateHistoryBrowsing: true,
      containers: ["#main", ".js-header"],
      plugins: [
        new SwupPreloadPlugin(),
        new SwupScrollPlugin({
          animateScroll: false,
        }),
        new SwupBodyClassPlugin({
          prefix: "page-",
        }),
      ],
    };

    const swup = new Swup(options);

    swup.on("contentReplaced", () => {
      checks();
      swupReload();
      swupActiveLinks(); // trigger after swup
    });

  }

  const slider1 = document.querySelector(".swiper-container-1");
  var slider1state = slider1.currentStyle
    ? slider1.currentStyle.display
    : getComputedStyle(slider1, null).display;

  if (slider1state != "none") {
    let swiper1 = new Swiper(".swiper-container-1", {
      modules: [Autoplay, EffectFade],
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 1000,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
      },
      loop: true,
      on: {
        transitionStart: function () {
          let index1 = this.realIndex + 1; /* slide 1 => slides[1] */
          let current_data1 = this.slides[index1].dataset.text;
          console.log(current_data1);
          document.body.setAttribute("data-text", current_data1);
        },
      },
    });
  }

  const slider2 = document.querySelector(".swiper-container-2");
  var slider2state = slider2.currentStyle
    ? slider2.currentStyle.display
    : getComputedStyle(slider2, null).display;

  if (slider2state != "none") {
    let swiper2 = new Swiper(".swiper-container-2", {
      modules: [Autoplay, EffectFade],
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 1000,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
      },
      loop: true,
      on: {
        transitionStart: function () {
          let index2 = this.realIndex + 1; /* slide 1 => slides[1] */
          let current_data2 = this.slides[index2].dataset.text;
          console.log(current_data2);
          document.body.setAttribute("data-text", current_data2);
        },
      },
    });
  }

  initSwup();

}

function swupActiveLinks() {
  let currentPath = window.location.pathname;
  let links = document.querySelectorAll("nav a"); // <- put your link selector here
  for (const link of links) {
    let linkPath = new URL(link.href).pathname;
    link.ariaCurrent = linkPath == currentPath ? "page" : false;
  }
}

function swupReload() {

  document.body.setAttribute("data-menu-open", "false");
  document.body.classList.remove("no-scroll");
  isNavToggled = false;

  intro(introRan, isHomepage);
  nav(isNavToggled,isPanelToggled);
  collapsibleText();


}

function init() {

  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }

  const introelement = document.getElementById("intro");
  if (typeof introelement != "undefined" && introelement != null) {
    intro(introRan, isHomepage);
    introRan = true;
  }

  intro(introRan, isHomepage);
  nav(isNavToggled);
  collapsibleText();

}

checks();
setupPlugins();
init();
